import React  from 'react';
import { ReactNode } from 'react';
import { useTeamSetupAreasContextRequired } from './TeamSetupAreasContext';
import { InformationMessage } from 'features/nekst-widgets';
import useSettingsNavigator from '../settingsNavigator';
import { TextLink } from 'ui-builder';

export default function SetupAreasRequiredWrapper(
  props: {
    children: ReactNode,
  }
) {
  const teamSetupAreasContext = useTeamSetupAreasContextRequired();

  const settingsNavigator = useSettingsNavigator();

  if (teamSetupAreasContext.teamSetupAreas.length > 0) {
    return props.children;
  } else {
    return (
      <InformationMessage>
        This feature is not available because you don't have any markets or processes set up yet.
        Please add a market from the available options or create a custom process in the
        {' '}
        <TextLink
          href={settingsNavigator.getMarketsLink()}
        >
          Markets section
        </TextLink>.
      </InformationMessage>
    )
  }
}
